module.exports = __webpack_public_path__ + "img/wait-times.53ae97e3.png";